import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

export var ProviderErrorCode;

(function (ProviderErrorCode) {
  // Thrown when accessing subscription features when they are disabled.
  ProviderErrorCode[ProviderErrorCode["SubscriptionsUnavailable"] = 4000] = "SubscriptionsUnavailable"; // Thrown when request is missing required params or data

  ProviderErrorCode[ProviderErrorCode["InvalidRequest"] = 4001] = "InvalidRequest";
})(ProviderErrorCode || (ProviderErrorCode = {}));

export var ProviderError = /*#__PURE__*/function (_Error) {
  _inherits(ProviderError, _Error);

  var _super = _createSuper(ProviderError);

  function ProviderError(message, code) {
    var _this;

    _classCallCheck(this, ProviderError);

    _this = _super.call(this, message);
    _this.name = 'ProviderError'; // Maintains proper stack trace for where our error was thrown (only available on V8)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), ProviderError);
    }

    _this.code = code;
    return _this;
  }

  _createClass(ProviderError, null, [{
    key: "SubscriptionsUnavailable",
    value: function SubscriptionsUnavailable() {
      return new ProviderError('Subscriptions are disabled. Enable block polling to use this feature.', ProviderErrorCode.SubscriptionsUnavailable);
    }
  }, {
    key: "InvalidRequest",
    value: function InvalidRequest(reason) {
      return new ProviderError("Invalid request: ".concat(reason), ProviderErrorCode.InvalidRequest);
    }
  }]);

  return ProviderError;
}( /*#__PURE__*/_wrapNativeSuper(Error));